module.exports = __webpack_public_path__ + "img/latest-news.4c1483f.webp";